import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Accordion } from '@delmonicos/shared-design-system-react/src/components/accordion/accordion';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import {
  Icon,
  IconSize,
} from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextColor,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { useTranslation } from 'react-i18next';

import { useTokenContext } from '../../token.context';

export const AccessCardComponent = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const token = useTokenContext();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Card flex={1} gap={GapEnum.M} direction="column">
      <AccentTitle
        icon="electric-terminal"
        as={HeadingEnum.H2}
        variant={AccentVariantEnum.Secondary}
        text={t('$.token-details.access.title')}
      />
      <Stack gap={GapEnum.S} justifyContent="space-between" alignItems="center">
        <Stack gap={GapEnum.XS} alignItems="center">
          <Icon name="wifi" iconSize={IconSize.Small} />
          <Text
            fontSize={TextFontSize.Small}
            color={TextColor.Secondary}
            uppercase>
            {t('delmonicos-shared-sdk.outputs-token.whitelist')}
          </Text>
        </Stack>
        <Text>
          {t(
            `delmonicos-shared-sdk.ocpi-protocol-enums.white-list-type.${token.whitelist}`,
          )}
        </Text>
      </Stack>
      <Divider />
      <Accordion
        title={
          <Stack gap={GapEnum.XS} alignItems="center">
            <Icon name="electric-terminal" iconSize={IconSize.Small} />
            <Text bold>
              {t(`delmonicos-shared-sdk.enums-token-type.${token.type}`)}
            </Text>
          </Stack>
        }>
        <Stack
          gap={GapEnum.S}
          justifyContent="space-between"
          alignItems="center">
          <Stack gap={GapEnum.XS} alignItems="center">
            <Icon name="server-06" iconSize={IconSize.Small} />
            <Text
              fontSize={TextFontSize.Small}
              color={TextColor.Secondary}
              uppercase>
              {t('$.token-details.network')}
            </Text>
          </Stack>
          <Text>-{/* TODO: waiting backend implementation */}</Text>
        </Stack>
      </Accordion>
      <Divider />
      <Stack gap={GapEnum.S} justifyContent="space-between" alignItems="center">
        <Stack gap={GapEnum.XS} alignItems="center">
          <Icon name="electric-terminals" iconSize={IconSize.Small} />
          <Text
            fontSize={TextFontSize.Small}
            color={TextColor.Secondary}
            uppercase>
            {t('$.token-details.roaming')}
          </Text>
        </Stack>
        <Text>-{/* TODO: waiting backend implementation */}</Text>
      </Stack>
      <Stack gap={GapEnum.XS} alignItems="center">
        <Icon name="receipt-check" iconSize={IconSize.Small} />
        <Text bold fontSize={TextFontSize.Medium}>
          {t('$.token-details.invoicing')}
        </Text>
      </Stack>
      <Stack gap={GapEnum.S} justifyContent="space-between" alignItems="center">
        <Stack gap={GapEnum.XS} alignItems="center">
          <Icon name="dataflow-04" iconSize={IconSize.Small} />
          <Text
            fontSize={TextFontSize.Small}
            color={TextColor.Secondary}
            uppercase>
            {t('delmonicos-shared-sdk.outputs-gateway-token.customer')}
          </Text>
        </Stack>
        <Text>{token.customer?.name ?? '-'}</Text>
      </Stack>
      <Divider />
      <Accordion
        title={
          <Stack gap={GapEnum.XS} alignItems="center">
            <Icon name="electric-terminal" iconSize={IconSize.Small} />
            <Text bold>{t('$.token-details.offline-access')}</Text>
          </Stack>
        }>
        <Stack
          gap={GapEnum.S}
          justifyContent="space-between"
          alignItems="center">
          <Stack gap={GapEnum.XS} alignItems="center">
            <Icon name="electric-terminal" iconSize={IconSize.Small} />
            <Text
              fontSize={TextFontSize.Small}
              color={TextColor.Secondary}
              uppercase>
              {t('$.token-details.charge-points')}
            </Text>
          </Stack>
          <Text>-{/* TODO: waiting backend implementation */}</Text>
        </Stack>
      </Accordion>
    </Card>
  );
};
